<template>
  <v-navigation-drawer
    v-model="showMenu"
    :width="400"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-progress-linear indeterminate v-if="data_is_loading"></v-progress-linear>
    <v-expansion-panels
      v-model="active_panels"
      multiple
      accordion
      v-if="!data_is_loading"
    >
      <v-expansion-panel @click="toggleShorelines">
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-checkbox
              :value="open"
              :input-value="open"
              label="Shorelines"
              class="menu-checkbox"
            ></v-checkbox>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="hoveredDate">
            Hovered Shoreline Date:<br />
            <b>{{ hoveredDate }}</b>
          </div>
          <v-container class="ma-0 pa-0">
            <v-row>
              <v-col class="pb-0"><b>Legend</b></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col align="left">1984-12-30</v-col>
              <v-col align="right">2019-07-13</v-col>
            </v-row>
          </v-container>
          <div
            class="legend legend-shoreline"
            style="width: 100%; height: 30px"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        v-for="layer in resultLayer"
        @click="toggleResults(layer)"
        :key="layer.name"
      >
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-checkbox
              :value="open"
              :input-value="open"
              :label="layer.title"
              class="menu-checkbox"
            ></v-checkbox>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p v-if="layer.infoText">{{ layer.infoText }}</p>
          <v-list v-if="!layer.infoText" disabled dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="#000000">mdi-checkbox-blank</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >Artificial accumulation (constructions)</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="#808080">mdi-checkbox-blank</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >Stable, no significant change</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="#0000ff">mdi-checkbox-blank</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Significant accumulation</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="#ff0000">mdi-checkbox-blank</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Significant erosion</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div v-if="layer.legend">
            <v-container class="ma-0 pa-0">
              <v-row>
                <v-col class="pb-0"><b>Legend</b></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col align="left">{{ layer.min }} m</v-col>
                <v-col align="center">0 m</v-col>
                <v-col align="right">>{{ layer.max }} m</v-col>
              </v-row>
            </v-container>
            <div
              class="legend legend-results"
              style="width: 100%; height: 30px"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <currents-expansion-panel />
      <waves-expansion-panel />
      <v-expansion-panel
        disabled
        v-for="layerName in disabledLayer"
        :key="layerName"
      >
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-checkbox
              disabled
              :value="open"
              :input-value="open"
              :label="layerName"
              class="menu-checkbox"
            ></v-checkbox>
          </template>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import MapServices from "@/services/mapbox.service";
import currentsExpansionPanel from "@/components/layer/currentsExpansionPanel";
import wavesExpansionPanel from "@/components/layer/wavesExpansionPanel";

export default {
  name: "LayerMenu",
  components: {
    currentsExpansionPanel,
    wavesExpansionPanel
  },
  data: () => ({
    active_panels: [],
    shorelinesActive: false,
    resultLayer: {},
    disabledLayer: [
      "Turbidity",
      "Digital Surface and Terrain Model",
      "Wind speed and direction",
      "Change Rate [m/y]",
      "Net Shoreline Movement [m]",
      "Shoreline stability",
      "Satellite Imagery",
      "Satellite Derived Bathymetry"
    ]
  }),
  computed: {
    ...mapGetters("map", ["data_is_loading"]),
    ...mapState("map", ["hoveredDate"]),
    showMenu: {
      get() {
        return this.$store.state.app.showMenu;
      },
      set(val) {
        this.$store.commit("app/TOGGLE_MENU", val);
      }
    }
  },
  methods: {
    toggleShorelines() {
      if (this.shorelinesActive) {
        MapServices.removeLayer("shorelines_layer");
        this.shorelinesActive = false;
      } else {
        MapServices.addShorelines();
        this.shorelinesActive = true;
      }
    },
    toggleResults(layer) {
      if (layer.active) {
        MapServices.removeLayer(layer.name);
        layer.active = false;
      } else {
        MapServices.addResults(layer);
        layer.active = true;
      }
    }
  }
};
</script>

<style scoped>
.menu-checkbox {
  height: 30px;
  padding: 0;
  margin: auto 0;
}

.legend {
  border-width: 1px;
  border-color: black;
  border-style: solid;
}

.legend-results {
  background: linear-gradient(
    to right,
    #ca0020 9%,
    #df5251 18%,
    #f4a582 27%,
    #f6cebd 36%,
    #f7f7f7 49%,
    #c5deeb 62%,
    #92c5de 75%,
    #4b9bc7 97%,
    #0571b0 100%
  );
}
.legend-shoreline {
  background: linear-gradient(to right, #fde725 0%, #238a8d 50%, #450d54 100%);
}
</style>
